// Az `ExerciseResults` komponens egy rácsszerkezetben jeleníti meg az edzéseket, és lehetővé teszi a további edzések betöltését.

import React, { useState } from 'react';
import { Box, Grid, Button } from '@mui/material';
import ExerciseCard from './ExerciseCard';

// Az `ExerciseResultsProps` interfész meghatározza a komponens által elvárt `exercises` prop típusát.
interface ExerciseResultsProps {
  exercises: any[];
}

const ExerciseResults: React.FC<ExerciseResultsProps> = ({ exercises }) => {
  // Az állapot a jelenleg látható edzések számát tárolja.
  const [visibleExercises, setVisibleExercises] = useState<number>(10);

  // Függvény a további edzések betöltéséhez.
  const loadMoreExercises = () => {
    setVisibleExercises((prev) => prev + 10);
  };

  return (
    <Box sx={{ mt: '30px', px: '20px' }}>
      <Grid container spacing={3}>
        {/* Az edzések megjelenítése, korlátozva a látható számot */}
        {exercises.slice(0, visibleExercises).map((exercise) => (
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4} key={exercise.id}>
            <ExerciseCard exercise={exercise} />
          </Grid>
        ))}
      </Grid>

      {/* 'Load More' gomb, ha vannak még további edzések */}
      {visibleExercises < exercises.length && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
          <Button variant="contained" onClick={loadMoreExercises}>
            Load More
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ExerciseResults;
